import React from 'react';
import { curry } from 'lodash';

import CaseStatusContext from './CaseStatusContext';
import { PANEL_STATUSES } from './constants';

const validPanelStatus = Object.values(PANEL_STATUSES);

const buildConsumerChild = curry(
  (WrappedComponent, panelName, componentProps, consumerProps) => {
    const { updateCasePanelStatusFactory, casePanelStatuses } = consumerProps;

    // This factory creates a debounced context updater unique
    // to the scope of the current use of this HOC.
    const updateStatus = updateCasePanelStatusFactory(panelName);

    const setStatus = (panelStatus, fieldsStatus) => {
      if (!validPanelStatus.includes(panelStatus)) return;

      updateStatus(panelStatus, fieldsStatus);
    };

    return (
      <WrappedComponent
        {...componentProps}
        casePanelStatuses={casePanelStatuses}
        setCasePanelComplete={fs => setStatus(PANEL_STATUSES.complete, fs)}
        setCasePanelIncomplete={fs => setStatus(PANEL_STATUSES.incomplete, fs)}
        setCasePanelInvalid={fs => setStatus(PANEL_STATUSES.invalid, fs)}
        setCasePanelPartial={fs => setStatus(PANEL_STATUSES.partial, fs)}
        setCasePanelStatus={setStatus}
      />
    );
  },
);

const withCasePanelStatusActions = panelName => WrappedComponent => componentProps => (
  <CaseStatusContext.Consumer>
    {buildConsumerChild(WrappedComponent, panelName, componentProps)}
  </CaseStatusContext.Consumer>
);

export default withCasePanelStatusActions;



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/withCasePanelStatusActions.js